import React, { useState, useEffect } from 'react';
import { useAuth } from '../App';
import { api } from '../api';
import { Menu, Shield } from 'lucide-react';
import AppSidebar from './AppSidebar';
import BottomTabBar from './BottomTabBar';

const PageLayout = ({ title, headerActions, headerSub, children, padded = true, maxWidth = "max-w-7xl" }) => {
  const { user, isAdmin } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMinor, setIsMinor] = useState(false);

  // Guardian session — read directly from user context (no API call)
  const isGuardianSession = !!user?.guardian_session;

  // Minor detection — check profile DOB once
  useEffect(() => {
    api.get('/profile').then(res => {
      const dob = res.data?.date_of_birth;
      if (dob) {
        const birth = new Date(dob);
        const now = new Date();
        let age = now.getFullYear() - birth.getFullYear();
        const m = now.getMonth() - birth.getMonth();
        if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age--;
        if (age < 18) setIsMinor(true);
      }
    }).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <AppSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main className="lg:ml-64">
        {/* Guardian session indicator — informational only */}
        {isGuardianSession && (
          <div className="bg-purple-600 text-white px-4 py-1.5 flex items-center justify-center gap-2" data-testid="guardian-view-bar">
            <Shield className="w-3.5 h-3.5" />
            <span className="text-xs font-medium">Guardian View</span>
          </div>
        )}

        <header className={`sticky top-0 z-30 backdrop-blur-md border-b ${isMinor ? 'bg-purple-100/80 border-purple-200' : 'bg-white/80 border-slate-200'}`}>
          <div className="flex flex-wrap items-center justify-between gap-2 px-4 sm:px-6 min-h-[72px] py-3">
            <div className="flex items-center gap-3">
              {isAdmin && (
                <button
                  className="lg:hidden p-2 rounded-lg hover:bg-slate-100"
                  onClick={() => setSidebarOpen(true)}
                  aria-label="Open navigation menu"
                >
                  <Menu className="w-6 h-6 text-slate-600" />
                </button>
              )}
              <div>
                <h1 className="text-xl font-heading font-bold text-slate-800">{title}</h1>
                {headerSub && <p className="text-sm text-slate-500 hidden sm:block">{headerSub}</p>}
              </div>
            </div>
            {headerActions && (
              <div className="flex items-center gap-2 flex-wrap">
                {headerActions}
              </div>
            )}
          </div>
        </header>

        <div className={padded ? `p-4 sm:p-6 ${maxWidth} mx-auto` : ''}>
          {children}
        </div>
      </main>

      {!isAdmin && <BottomTabBar />}
    </div>
  );
};

export default PageLayout;
